import {Component} from '@angular/core';
import {WidgetInputDirective} from '../../directives/widget-input.directive';

@Component({
  selector: 'pt-widget-text',
  template: `
    <div
      class='widget-border'
      data-testid="widget-text"
      id='widget_{{initializationWidget.internalId}}'
      [ngSwitch]='initializationWidget?.version'>

      <pt-widget-text-v0
        *ngSwitchCase='0'
        [lockAcquired]='lockAcquired'
        [initializationWidget]='initializationWidget'
        [status]='status'>
      </pt-widget-text-v0>

      <pt-widget-version-missing
        *ngSwitchDefault
        [type]='initializationWidget?.type'
        [label]='initializationWidget?.label'
        [version]='initializationWidget?.version'>
      </pt-widget-version-missing>

    </div>
  `
})
export class WidgetTextComponent extends WidgetInputDirective {
}
